import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import { Avatar } from 'components/avatar';
import { useCurrentUser } from 'providers/UserProvider';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { navigate } from 'utils/navigate';
import { CINDER_URLS } from 'utils/cinder-urls';
import Button from '../button';
import { NotificationsButton } from '../notifications/NotificationsButton';
import './styles.less';

interface Props {
  disabled?: boolean;
}

const ProfileActions: React.FC<Props> = ({ disabled = false }) => {
  const { t } = useTranslation();
  const { data } = useCurrentUser();
  const { id: userId } = data;

  const items: MenuProps['items'] = [
    { label: <a href={CINDER_URLS.userEdit(userId)}>{t('profile_actions.profile')}</a>, key: '1' },
    {
      label: (
        <a
          href="/notification-preferences"
          onClick={(e) => {
            e.preventDefault();
            navigate('/notification-preferences');
          }}
        >
          {t('profile_actions.notification_preferences')}
        </a>
      ),
      key: '2',
    },
    { label: <a href={CINDER_URLS.logout}>{t('profile_actions.logout')}</a>, key: '3' },
  ];

  return (
    <>
      <NotificationsButton />
      <Dropdown overlayClassName="avatar-dropdown" menu={{ items }} trigger={['click']} disabled={disabled}>
        <Button className="avatar-button" variant="neutral" type="default" onClick={(e) => e.preventDefault()}>
          <Avatar userFirstName={data.firstName} userLastName={data.lastName} profileImage={data.avatar}></Avatar>
        </Button>
      </Dropdown>
    </>
  );
};

export default ProfileActions;
